import type { PhotoItemDto } from '@customTypes/types';
import { Image, Loader, Stack, Text } from '@mantine/core';
import { useState } from 'react';
import { PhotoView } from 'react-photo-view';

import { resolveImagePath } from '@/shared/helper/resolveImagePath';
import { translate } from '@/shared/i18n/translate';

const ImageItem = ({ item }: { item: PhotoItemDto }) => {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        minHeight: '190px',
        borderRadius: 20,
        overflow: 'hidden'
      }}
    >
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.5)'
          }}
        >
          <Loader />
        </div>
      )}
      <PhotoView key={item.filePath} src={resolveImagePath(item.filePath)}>
        <Image
          src={resolveImagePath(item.filePath)}
          style={{ borderRadius: '20px' }}
          onLoad={() => setIsLoading(false)}
        />
      </PhotoView>
    </div>
  );
};

export const PhotoList = ({ data }: { data: PhotoItemDto[] }) => (
  <Stack gap={16}>
    {data.length ? (
      data.map((item) => <ImageItem key={item.filePath} item={item} />)
    ) : (
      <Text>{translate('commons.notFound.generic')}</Text>
    )}
  </Stack>
);
